import { CircularProgress, Stack } from "@mui/material";

export const CustomLoadingOverlay = () => {
    return (
        <Stack direction="row" height="100%" alignItems="center" justifyContent="center" spacing={1}>
            <CircularProgress size={50}/>
        </Stack>
    );
};